/*
 * sectionLabel is the shared treatment for nav and panel section headings — an
 * uppercased, slightly tracked, dimmed label. The Text component opts in via
 * variant="section-label" so call sites stay free of inline tt/lts/c/fw/size
 * noise.
 *
 * The class is doubled to raise its specificity to (0,2,0), for the same reason
 * modal.module.css doubles .title: it lands on a <Text> root whose own class already
 * declares font-size, font-weight and color at (0,1,0), and a tie there is settled by
 * stylesheet injection order rather than by intent.
 */
.sectionLabel.sectionLabel {
  font-size: 11px;
  font-weight: 700;
  color: var(--mantine-color-dimmed);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
